export default "/images/3db8985bdc610b1a8c34dc47cd280269.avif";